import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-parent-faq',
  imports: [CommonModule, RouterModule],
  templateUrl: './parent-faq.component.html',
  styleUrl: './parent-faq.component.css',
})
export class ParentFaqComponent {

    constructor() {}
 
    ngOnInit() {}

}
